module.exports = __webpack_public_path__ + "static/media/image10.0e7c393f.jpg";